import EndpointVerification from '@components/EndpointVerification';
import { useBookingContext } from '@contexts/BookingContext';
import { requestCode } from '@utils/api';
import { useTranslation } from 'react-i18next';


const PatientConfirmationStep = () => {
  const { bookingData, goForward, goBack } = useBookingContext();
  const { i18n } = useTranslation();

  const handleVerificationSuccess = async () => {
    goForward('complete');
  };

  const handleSendVerificationCode = async () => {
    const endpoint = bookingData.platformPreference === 'sms' ? bookingData.phone : bookingData.email;
    await requestCode(endpoint, bookingData.platformPreference, i18n.language);
  };

  const handleBack = () => {
    goBack();
  };

  return (
    <EndpointVerification 
      platform={bookingData.platformPreference} 
      endpoint={bookingData.platformPreference === 'sms' ? bookingData.phone : bookingData.email} 
      onSuccess={handleVerificationSuccess}
      onSendVerificationCode={handleSendVerificationCode}
      onBack={handleBack}
      autoSendCode={false}
    />
  );
};

export default PatientConfirmationStep;
